export interface Permission {
  id: string
  label: string
  feature: string
}

export interface Role {
  id: string
  name: string
  description: string
  permissions: string[]
  isSystem: boolean
  createdAt: any
  updatedAt: any
  createdBy: string
}

export interface RoleInfo {
  id: string
  displayName: string
}

/**
 * Default permission set for the non-admin system role, used as the fallback
 * when a role doc doesn't exist yet (e.g. before roles are seeded for an org).
 * Cloned from admin-console's `role.model.ts` — `OrgContextService` needs it to
 * build the fallback member role. Admin and member are the only system roles.
 */
export const DEFAULT_MEMBER_PERMISSIONS = [
  'workflows.write', 'workflows.delete',
  'members.read', 'billing.read', 'api-keys.read', 'settings.read', 'analytics.read', 'permissions.read',
  'products.read', 'models.read', 'integrations.read',
  'tools.google-maps', 'tools.google-search', 'tools.web-search', 'tools.perplexity', 'tools.firecrawl', 'tools.browserbase',
]
